import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import { useContext } from "react";
import { searchByProp } from "utils/search";
import { IncProductSearchContext } from "..";
import { FETCH_MARKETTIME_PRODUCTS, FETCH_ODOO_MT_PRODUCTS } from "./graphql";
import ProductsView from "./ProductsView";

const MarketTimeProductsView = () => {
  const { q } = useContext(IncProductSearchContext);
  const fetchMtOrders = useQuery(FETCH_MARKETTIME_PRODUCTS);
  const fetchMtOdooProducts = useQuery(FETCH_ODOO_MT_PRODUCTS);

  const loading = fetchMtOrders.loading || fetchMtOdooProducts.loading;
  const error = fetchMtOrders.error || fetchMtOdooProducts.error;

  if (loading)
    return (
      <div className="p-6">
        <InlineSpinner />
      </div>
    );
  if (error) return <Errors error={error} />;

  const res = JSON.parse(fetchMtOrders.data.mtProducts);
  if (res.error) return <Errors error={res.error} />;

  const odooProducts = JSON.parse(fetchMtOdooProducts.data.odooProducts);

  // Sort by product isAvailable yes then no
  const products = [...res.response]
    .filter((i) => searchByProp(i, ["name", "itemNumber", "upc1"], q))
    .sort((a, b) => {
      if (a.isAvailable && !b.isAvailable) return -1;
      if (!a.isAvailable && b.isAvailable) return 1;
      return 0;
    })
    .map((i) => {
      const odooProduct = odooProducts.find(
        (p) => `${p.x_studio_markettime_product_id}` === `${i.recordID}`,
      );
      return { ...i, odooProduct };
    });

  return <ProductsView products={products} />;
};

export default MarketTimeProductsView;
